import { render, staticRenderFns } from "./DashboardBody.vue?vue&type=template&id=5997eff2&scoped=true&"
import script from "./DashboardBody.vue?vue&type=script&lang=js&"
export * from "./DashboardBody.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBody.vue?vue&type=style&index=0&id=5997eff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997eff2",
  null
  
)

export default component.exports